<template>
  <form-wrapper
    title="Size Of Header Image Setup"
    :hint-images="hint"
  >
    <size-settings
      title="Home Page Header Image Height (px)"
      :min-val="425"
      :max-val="1190"
      v-model="settings.home"
    />
    <size-settings
      title="About Page Header Image Height (px)"
      :min-val="100"
      :max-val="1190"
      v-model="settings.about"
    />
    <size-settings
      title="Venue Page Header Image Height (px)"
      :min-val="400"
      :max-val="1190"
      v-model="settings.venue"
    />
    <size-settings
      title="Agenda Page Image Height (px)"
      :min-val="100"
      :max-val="1190"
      v-model="settings.agenda"
    />
    <size-settings
      title="Speakers Page Header Image Height (px)"
      :min-val="100"
      :max-val="1190"
      v-model="settings.speakers"
    />
    <size-settings
      title="Sponsors Page Header Image Height (px)"
      :min-val="100"
      :max-val="1190"
      v-model="settings.sponsors"
    />
    <size-settings
      title="Attendees Page Header Image Height (px)"
      :min-val="100"
      :max-val="1190"
      v-model="settings.attendees"
    />
    <size-settings
      title="Crypto Trading Floor Page Header Image Height (px)"
      :min-val="100"
      :max-val="1190"
      v-model="settings.crypto"
    />

    <reset-submit
      @submit="generateSubmit('pageHeaderHeight')"
      @reset="resetSettings"
    />

  </form-wrapper>

</template>

<script>
  import FormWrapper from './FormWrapper'
  import SizeSettings from './../styleSettingsFormComponents/SizeSettings'
  import { generateMapState } from './utils'
  import ResetSubmit from './../styleSettingsFormComponents/ResetSubmit'
  import { submitGlobalStyles } from '@/utils/mixins'

  export default {
    name: 'HeaderImageSizeSetup',
    components: {
      FormWrapper,
      SizeSettings,
      ResetSubmit
    },
    mixins: [submitGlobalStyles],
    data () {
      return {
        settings: {
          home: 520,
          about: 290,
          venue: 600,
          agenda: 80,
          speakers: 187,
          sponsors: 150,
          attendees: 190,
          crypto: 360,
        },
        hint: [
          {url: '/static/info/Header_About.png', title: 'About page' },
          {url: '/static/info/Header_HP.png', title: 'Home page' },
          {url: '/static/info/Header_Venue.png', title: 'Venue page' }
        ]
      }
    },
    computed: {
      ...generateMapState('pageHeaderHeight')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleForms/HeaderImageSizeSetup.vue